// extracted by mini-css-extract-plugin
module.exports = {"secondary":"secondary_button-module__secondary--aJ0Vo"};